export default __webpack_public_path__ + "img/000d741724fae479e433fa8c99846d0c.png";